import userInfo from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
export const useIsSeats = () => {
  const [isSeats, setIsSeats] = useState(null);
  useEffect(() => {
    userInfo().then(({
      user
    }) => user.scopes.includes('seats-access')).then(setIsSeats).catch(() => setIsSeats(false));
  }, []);
  return isSeats;
};